import React, { useEffect, useState } from 'react';
import {Image} from '@shopify/hydrogen';
import 'rc-slider/assets/index.css';
import arrowSearch from '../../../assets/image/arrow-search.svg';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { useAppDispatch, useAppSelector } from '../../../lib/hooks';
import { executeSearch, updateFilters } from '../../../store/slices/search';
import { sendEvent } from '../../../lib/analitycs';
import { appendValueToUrlParam, resetValueParamUrl } from '../../../lib/Utils'

export default function Price({}) {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.search)?.response;
  const filtersActive = useAppSelector((state) => state.search)?.filters;
  const [value, setValue] = useState([0, 0]); // current value
  const [valueRange, setValueRange] = useState([0, 0]);
  const [isActive, setIsActive] = useState(false);

  useEffect(()=>{
  }, [])

  useEffect(()=>{
    try{

      if(filters){
        let min = parseInt(filters.price[0].item);
        let max = parseInt(filters.price[(filters.price.length - 1)].item);

        if(filtersActive?.price){
          setValue([filtersActive.price[0], filtersActive.price[1]]);
        }else{
          setValue([min, max]);
        }

        setValueRange([min, max]);
      }
    }catch(e){
      // console.log(e)
    }
  }, [filters])

  const toggleOpen = ()=>{
    setIsActive(!isActive);
  }

  const handleRange = async (currentValue) => {
    setValue(currentValue);
  };

  const onThumbDragEnd = async () => {
    dispatch(updateFilters({
      section: 'price', 
      value: value
    }))
    
    resetValueParamUrl('price');
    appendValueToUrlParam('price', value[0]+'|'+value[1]);
    dispatch(executeSearch());

    sendEvent('filter_interaction',{
      filter_option : 'price',
      option_selected: JSON.stringify(value),
    });
  };

  return (
    <>
      <div className="filter-item border-b px-10 py-3 ">
      <div 
          className={`
            accordion-header font-semibold text-lg flex justify-between cursor-pointer 
            ${!isActive ? 'accordion-close' : 'accordion-open'}
            `}
          onClick={toggleOpen} 
        >
          <label> Precio </label>
          <Image
            src={arrowSearch}
            height={5}
            width={10}
            className="inline icon-arrow-down"
            alt="Search"
            style={{
              transform: isActive ? 'rotate(0deg)' : 'rotate(-90deg)',
            }}
          />
        </div>
        <div className={`
            accordion-content flex flex-wrap w-full
            ${!isActive ? 'hidde-accordeon' : ''}
          `}>
          <div className="filter-range flex justify-center items-center text-purple-120 flex-wrap">
            <div className="font-semibold p-2">${value[0]}</div>
            <div className="font-semibold"> - </div>
            <div className="font-semibold p-2"> ${value[1]}</div>
          </div>
          {(valueRange[0]  || valueRange[1]) && 
            <RangeSlider
              defaultValue={value}
              min={valueRange[0]}
              max={valueRange[1]}
              onInput={handleRange}
              onThumbDragEnd={onThumbDragEnd}
            />
          } 
        </div>
      </div>
    </>
  );
}
